import styled from 'styled-components';
import { Button } from '../../../shared/components/button';
import { media } from '../../../theme/media';

export const Container = styled.div`
  margin-bottom: 56px;

  ${media.desktop`
    margin-bottom: 80px;
  `};
`;

export const LoadMoreButton = styled(Button)`
  padding: 26px;
  width: 320px;

  ${media.tablet`
    width: 450px;
  `}
`;
